import Vue from 'vue'

import SvgIcon from '@/components/SvgIcon' // svg component

import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'

// register globally
Vue.component('svg-icon', SvgIcon)
